// extracted by mini-css-extract-plugin
export default {"button":"TooltipButton-button-0ba630d0554f642f7ba4764d2481d7b7"};